import React from "react";
import DualLabelSwitch from "../DualLabelSwitch/DualLabelSwitch";
import { useField, useFormikContext } from "formik";
import { PropTypes } from "prop-types";
import { Tooltip } from "../Tooltip";
import { Box } from "@mui/material";

const SwitchField = ({
  name,
  checkedValue,
  uncheckedValue,
  tooltip,
  ...switchProps
}) => {
  const [{ value }, , { setValue }] = useField(name);
  const { isSubmitting } = useFormikContext;
  const handleChange = ({ target: { checked } }) => {
    setValue(checked ? checkedValue : uncheckedValue);
  };
  const switchField = (
    <DualLabelSwitch
      disabled={isSubmitting || switchProps.disabled}
      onChange={handleChange}
      checked={value === checkedValue}
      {...switchProps}
    />
  );
  return !!tooltip ? (
    <Tooltip title={tooltip}>
      <Box flex={1}>{switchField}</Box>
    </Tooltip>
  ) : (
    switchField
  );
};

export default SwitchField;

SwitchField.propTypes = {
  name: PropTypes.string,
  checkedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  uncheckedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
